export const deviceTypes = ['web', 'ios', 'android'] as const
